import { Component, computed, effect, inject, signal, DestroyRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidebarService } from '../../services/sidebar.service';
import { SidebarPanelType } from '../../models/sidebar-panel';
import { CustomerPickupRequestService, CprFullDetail } from '../../../features/cprs/services/customer-pickup-request.service';
import { getOrderStatusLabel } from '../../constants/domain.constants';

@Component({
  selector: 'app-cpr-detail-panel',
  imports: [DatePipe],
  templateUrl: './cpr-detail-panel.component.html',
  styleUrl: './cpr-detail-panel.component.scss'
})
export class CprDetailPanelComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly sidebarService = inject(SidebarService);
  private readonly cprService = inject(CustomerPickupRequestService);

  readonly cpr = computed(() => {
    const panel = this.sidebarService.currentPanel();
    if (panel?.type === SidebarPanelType.CprDetail) {
      return panel.data;
    }
    return null;
  });

  readonly fullDetail = signal<CprFullDetail | null>(null);
  readonly detailLoading = signal(false);

  readonly statusLabel = computed(() => {
    const c = this.cpr();
    return c ? getOrderStatusLabel(c.status) : '';
  });

  constructor() {
    effect(() => {
      const c = this.cpr();
      if (c?.cprNumber) {
        this.detailLoading.set(true);
        this.fullDetail.set(null);
        this.cprService.getFullDetail(c.cprNumber)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (detail) => {
              this.fullDetail.set(detail);
              this.detailLoading.set(false);
            },
            error: () => this.detailLoading.set(false)
          });
      }
    });
  }
}
